var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5V19C4 20.105 4.895 21 6 21H18C19.105 21 20 20.105 20 19V8C20 6.895 19.105 6 18 6H5.5C4.672 6 4 5.328 4 4.5V4.5C4 3.672 4.672 3 5.5 3H18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4789 10.5C14.7489 10.5 15.5999 11.617 15.5999 12.658C15.5999 14.77 12.0639 16.5 11.9999 16.5C11.9359 16.5 8.3999 14.77 8.3999 12.658C8.3999 11.617 9.2519 10.5 10.5209 10.5C11.2469 10.5 11.7239 10.839 11.9999 11.142C12.2759 10.839 12.7519 10.5 13.4789 10.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanner);
export default __webpack_public_path__ + "static/media/planner.80f4a45a.svg";
export { ForwardRef as ReactComponent };